.root {
  color: #606060;
  font-size: 16px;

  & h1 {
    color: #2e4b64;
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 10px;
  }

  & h2 {
    color: #2e4b64;
    font-size: 19px;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  & h3 {
    color: #2e4b64;
    font-size: 16px;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  & p {
    line-height: 1.7em;
  }

  & img {
    max-width: 100%;
  }

  & code {
    background: #f0f0f0;
    font-size: 14px;
    margin: -2px 0;
    padding: 2px 4px;
  }
}
